export const GET_DOCUMENTS = "/admin_requests/documents";
export const DELETE_DOCUMENT = GET_DOCUMENTS;
export const ADD_DOCUMENT = GET_DOCUMENTS;
export const EDIT_DOCUMENT = GET_DOCUMENTS;
export const GET_DOCUMENT_DETAILS = GET_DOCUMENTS;
export const GET_CATEGORIES = `${GET_DOCUMENTS}/categories/`;
